import React from 'react';
import style from './SensorInMaintenanceWarningMessage.module.css';
import ExclamationWarningSvg from "../assets/svg/ExclamationWarningSvg";

function SensorInMaintenanceWarningMessage() {
    return (
        <div className={style.main}>
            <div>
                <ExclamationWarningSvg />
            </div>

            <div className={style.textContent}>
                <div className={style.title}>
                    Chwilowa przerwa w działaniu
                </div>

                <div className={style.explanation}>
                    Sensor obecnie nie działa z przyczyn niezależnych od nas. Poniżej prezentujemy dane historyczne. <br/>
                    Spróbuj ponownie później jeżeli zależy Ci na aktualnych pomiarach, udostępnimy je najszybciej jak to tylko będzie możliwe.
                </div>
            </div>
        </div>
    );
}

export default SensorInMaintenanceWarningMessage;